export enum CategoriesPosition {
  TOP = 'top',
  SIDE = 'side',
}

export enum Structure {
  ONE_COLUMN = 'oneColumn',
  TWO_COLUMNS = 'twoColumns',
}
